export default __webpack_public_path__ + "static/media/pfp-gray.15870677.svg";